import { ConfigStore, connectionStore, connectWithSubscriptions } from "../..";
export function connectWithToken(connectionName, subscribersStore, token) {
    const connection = connectionStore.get(connectionName);
    const connectionConfig = ConfigStore.config.urls[connectionName];
    if (connection && connectionConfig && typeof connectionConfig !== "string") {
        connection.updateToken(token);
        const url = {
            baseUrl: connectionConfig.baseUrl,
            queryParams: Object.assign(Object.assign({}, connectionConfig.queryParams), { jwt: ConfigStore.config.connections.jwt })
        };
        connectWithSubscriptions(connection, subscribersStore, url)
            .catch(console.error);
    }
    return token;
}
//# sourceMappingURL=connectWithToken.js.map